import {
    Flex,
    Container,
    Heading,
    Stack,
    Text,
    Button,
    Icon,
    IconProps,
    Box,
    Spinner,
    useToast
} from '@chakra-ui/react'
import React, { useState } from 'react';
// import { get_ghl_keap_creds } from '../apis/apiRequests';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ghl_auth } from '../apis/apiRequests';


export default function Authorize() {
    //hooks
    const toast = useToast();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    //states
    const [loading, setLoading] = useState(false);

    const authorize_ghl = () => {
        setLoading(true);
        var code = searchParams.get("code");
        console.log(code);

        let payload = {
            code: code
        }
        ghl_auth(payload)
        .then((result) => {
            if(result.data){
                result = result.data;
                console.log("Authorized", result);
                navigate("/success");
                toast({
                    title: 'Success!',
                    description: "GHL Account authorized!",
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                })
            } else {
                toast({
                    title: 'Failed!',
                    description: "Authorization failed!",
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                })
            }
        })
        .catch((error) => {
            if(error.response.data){
                console.log(error.response.data);
                toast({
                    title: 'Failed!',
                    description: error.response.data.errorMessage,
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                })
            } else {
                toast({
                    title: 'Failed!',
                    description: error.message,
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                })
            }

            // //Un comment the block of code below, in case error occurs
            // toast({
            //     title: 'Failed!',
            //     description: error.message,
            //     status: 'error',
            //     duration: 9000,
            //     isClosable: true,
            // })
        })
        .finally(() => {
            setLoading(false);
        })
    }

    return (
        <Box>
            <Container maxW={'5xl'}>
                <Stack
                    textAlign={'center'}
                    align={'center'}
                    spacing={{ base: 8, md: 10 }}
                    py={{ base: 20, md: 28 }}>
                    <Heading
                        fontWeight={600}
                        fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                        lineHeight={'110%'}
                    >
                        Authorize{" "}
                        <Text as={'span'} color={'orange.400'}>
                            GoHighLevel
                        </Text>
                        {" "}Account
                    </Heading>
                    <Text color={'gray.500'} maxW={'3xl'}>
                        Authorize your HighlLevel sub account by clicking on the button below.
                    </Text>
                    <Stack spacing={6} direction={'row'}>
                        <Button
                            rounded={'full'}
                            px={6}
                            colorScheme="green"
                            onClick={authorize_ghl}
                        >
                            {loading ? <Spinner /> : "Click to Authorize"}
                        </Button>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    )
}
